import styled from 'styled-components';

export const Container = styled.div`
    max-height: calc(100% - 59px);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    visibility: hidden;
    opacity: 0;
    text-align: center;
    transition: visibility 0.2s linear;
    // TODO: Add support for rgba transformation of hex -> rgb
    // background-color: rgba(${({ theme }) => theme.functionColor.function100}, 0.8);
    background-color: rgba(26, 26, 26, 0.8);
    color: ${({ theme }) => theme.functionColor.function0};
    height: calc(100% - 99px);
`;

export const Wrapper = styled.div`
    width: 100%;
    padding: 0 15px;

    // TODO: Is this shared?
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const InfoHeader = styled.p`
    margin: 0;
    font-family: var(--font-default), Arial, sans-serif;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    font-size: 1.2rem;
`;

export const InfoBannerText = styled.p`
    margin: 10px 0;
    font-weight: 400;
    line-height: 20px;
    font-size: 1.3rem;
`;

export const InfoBannerButton = styled.div`
    text-align: center;
    box-sizing: border-box;
    height: 48px;
    font-size: 15px;
    text-transform: uppercase;
    line-height: 21px;
    display: inline-flex;
    justify-content: center;
    cursor: pointer;
    transition: all 0.1s cubic-bezier(0.25, 0.5, 0.5, 1) 0s;
    background-color: transparent;
    color: ${({ theme }) => theme.functionColor.function0};
    border: 2px solid currentColor;
    border-radius: 4px;
    align-items: center;
    padding: 0 12px;
    font-weight: bold;

    &:hover {
        color: ${({ theme }) => theme.functionColor.function100};
        background-color: ${({ theme }) => theme.functionColor.function0};
    }
`;
